import React, {useEffect, useState} from 'react';
import {
  ButtonsContainer,
  Container,
  HeaderContainer,
  Title,
  IconButton,
  BodyContainer,
} from './styles';
import {theme} from '../../styles/darkTheme';
import HistoryIcon from '../../assets/icons/history.svg';
import AddIcon from '../../assets/icons/Add.svg';
import {useNavigate} from 'react-router-dom';
import {useQuery} from '../../hooks/useQuery';
import {useDispatch, useSelector} from 'react-redux';
import {parsePhoneNumber} from 'libphonenumber-js';
import {CLEAN_REMITTANCE, SET_USER} from '../../redux/actionTypes';
import {RootState} from '../../redux/reducers';
import {setChannelSearch} from '../../redux/actions/channel';
import ListChats from '../../components/organisms/lists/Chats';
import {chatClient} from '../../config/get-stream';
import LoadingSpinner from '../../components/atoms/LoadingSpinner';
import Footer from '../../components/molecules/Footer';

const Chats = () => {
  const history = useNavigate();
  const query = useQuery();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [valueFilter, setValueFilter] = useState('');
  const {channelSearch = [], id} = useSelector((state: RootState) => ({
    ...state.channel,
    ...state.user,
  }));

  const filterChats = channelSearch
    .filter(item => {
      if (!item.data) return false;

      if (item.data.name) {
        return (
          item.data.name
            .toLocaleLowerCase()
            .trim()
            .indexOf(valueFilter.toLocaleLowerCase().trim()) > -1
        );
      } else {
        const payload = Object.values(item.state.members).find(
          subItem => subItem.user_id !== id,
        );
        const messages = item.state.messages.length;

        return (
          payload &&
          payload.user &&
          payload.user.name &&
          payload.user.name
            .toLocaleLowerCase()
            .trim()
            .indexOf(valueFilter.toLocaleLowerCase().trim()) > -1 &&
          messages > 0
        );
      }
    })
    .slice(0, 5);

  const handleClickRemittanceRequest = () => {
    dispatch({type: CLEAN_REMITTANCE});
    history('/request_remittance');
  };

  const handleClickAddContact = () => {
    history('/add_contact');
  };

  const handleClickInfo = () => {
    history('/info');
  };

  const getUserData = () => {
    const queryNum = query.get('number');
    if (!queryNum) return null;
    const phoneNumber = parsePhoneNumber(`+${queryNum || ''}`);
    const data = {
      dialCountryCode: `+${String(phoneNumber.countryCallingCode)}`,
      mobileNumber: phoneNumber.nationalNumber,
    };
    dispatch({type: SET_USER, payload: data});

    return data;
  };

  /* No notification on web
  useEffect(() => {
    const refreshChat = () => {
      if (!id) {
        return;
      }
      setIsLoading(true);
      dispatch(setChannelSearch(id, () => setIsLoading(false)));
    };
    chatClient.on('notification.mark_read', refreshChat);
  }, []);
  */

  useEffect(() => {
    getUserData();
    const event = () => {
      dispatch(setChannelSearch(id, () => setIsLoading(false)));
    };
    event();
    chatClient.on('message.new', event);
  }, []);

  return (
    <Container theme={theme}>
      <HeaderContainer>
        <Title theme={theme}>Chats</Title>
        <ButtonsContainer>
          <IconButton
            src={AddIcon}
            backgroundColor={theme.primary}
            onClick={handleClickAddContact}
          />
          <IconButton onClick={handleClickRemittanceRequest} />
          <IconButton
            onClick={handleClickInfo}
            src={HistoryIcon}
            backgroundColor={theme.primary}
          />
        </ButtonsContainer>
      </HeaderContainer>
      <BodyContainer>
        {isLoading ? (
          <LoadingSpinner small width={50} height={50} />
        ) : (
          <ListChats chats={filterChats } />
        )}
      </BodyContainer>
      <Footer />
    </Container>
  );
};

export default Chats;
